/* eslint-disable @typescript-eslint/no-explicit-any */
import { maskSensitiveQueryParams } from 'lib/utils/urlMasking'

export const isClarityAvailable = (): boolean => {
    return typeof window !== 'undefined' && 'clarity' in window
}

export const setClarityTag = (tag: string): void => {
    if (isClarityAvailable()) {
        window.clarity('set', 'tag', tag)
    }
}

export const identifyClarity = (userId: string, traits?: Record<string, any>): void => {
    if (isClarityAvailable()) {
        window.clarity('identify', userId, traits)
    }
}

export const configureClarityPrivacy = (): void => {
    if (!isClarityAvailable()) return

    window.clarity('set', 'maskAllInputs', true)
    window.clarity('set', 'maskSensitiveInputs', true)

    const currentUrl = window.location.href
    const maskedUrl = maskSensitiveQueryParams(currentUrl)

    if (currentUrl !== maskedUrl) {
        window.clarity('set', 'url', maskedUrl)
    }
}

export const setClarityMaskedUrl = (url: string): void => {
    if (isClarityAvailable()) {
        const maskedUrl = maskSensitiveQueryParams(url)
        window.clarity('set', 'url', maskedUrl)
    }
}

interface ClarityStatic {
    (action: 'set', key: 'tag', value: string): void
    (action: 'set', key: 'url', value: string): void
    (action: 'set', key: 'maskAllText', value: boolean): void
    (action: 'set', key: 'maskAllInputs', value: boolean): void
    (action: 'set', key: 'maskSensitiveInputs', value: boolean): void
    (action: 'identify', userId: string, traits?: Record<string, any>): void
    (action: string, ...args: any[]): void
}

declare global {
    interface Window {
        clarity: ClarityStatic
    }
}
